/*
 * Copyright (c) 2024-2025.
 * The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from "react";
import {useTranslation} from "react-i18next";
import clsx from "clsx";
import {flexRender} from "@tanstack/react-table";
import SuspenseLoader from "components/SuspenseLoader";
import {InformationCircleIcon} from "@heroicons/react/24/outline";

interface TableBodyProps {
    colSpan?: number;
    tableInit: any;
    decorationId?: string;
    isTableStateSame?: boolean;
}

const TableBody = (props: TableBodyProps) => {
    const {t} = useTranslation();

    const decorationId = props.decorationId ? props.decorationId : "select";
    return (
        <tbody className={"TableBody relative h-auto"}>
            {props.tableInit.table.getRowModel().rows.map(row => {
                return (
                    <tr key={row.id} className={clsx("even:bg-gray-50 border-b border-b-gray-200/50 last:border-b-0")}>
                        {row.getVisibleCells().map(cell => {
                            if (cell.column.columnDef?.hideColumn === true) {
                                return <></>;
                            }
                            return (
                                <td
                                    key={cell.id}
                                    // className={clsx("h-[64px]", cell.column.id === decorationId ? "relative" : "px-3.5 first:pl-6 last:pr-6 py-3")}
                                    className={clsx("", cell.column.id === decorationId ? "relative" : "px-1.5 first:pl-3 last:pr-3 py-2")}
                                >
                                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                </td>
                            );
                        })}
                    </tr>
                );
            })}

            {/* fix - full height table if number of tr is small */}
            <tr className={"h-auto min-h-[0]"}>
                <td className={"p-0"} colSpan={props.colSpan ? props.colSpan : 10}></td>
            </tr>

            {/* not found */}
            {props.tableInit.table.getRowModel().rows.length === 0 && (
                <tr className={"bg-white"}>
                    <td className={"px-6 py-3 text-center"} colSpan={props.colSpan ? props.colSpan : 10}>
                        <div className={"flex flex-col items-center select-none"}>
                            <InformationCircleIcon className={"size-12"} />
                            <span>{t("No records found.")}</span>
                        </div>
                    </td>
                </tr>
            )}

            {/* loading data */}
            {(props.tableInit.isLoading && !props.isTableStateSame) && (
                <tr className={"absolute inset-0 flex justify-center items-center h-full w-full bg-white/50 backdrop-blur-sm"}>
                    <td colSpan={props.colSpan ? props.colSpan : 10}>
                        <SuspenseLoader />
                    </td>
                </tr>
            )}
        </tbody>
    );
};

export default TableBody;
